module.exports = __webpack_public_path__ + "static/img/4.3546bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/4.png
// module id = xPQ0
// module chunks = 0